import { MenuInitialState, useMenuState as useReakitMenu } from 'reakit';
import { spaces } from '../../settings';

/**
 * Tracks the internal state of the menu, and exposes functionality to compose your own.
 * This hook can be used to create a custom Menu component, by passing the returned state
 * to MenuButton, BaseMenu and custom components.
 *
 * Note: If using the default Menu component, this hook does not need to be used.
 */
export function useMenu(initialState?: MenuInitialState) {
    const menu = useReakitMenu({
        animated: 200, // Matches Select/Menu
        gutter: spaces.px['0.5bu'],
        loop: true,
        ...initialState,
    });

    return menu;
}
